import { Box } from "@mui/system";
import React from "react";
import Button from "../buttons/Buttons";
import styles from "./footerSection.module.scss";
import PropTypes from "prop-types";

const FooterButtonSection = (props) => {
  const { footerStyle, btnlist} = props;
  return (
    <Box className={`${styles.Detailfooter} ${footerStyle}`} data-testid="FooterButtonSection">
      {btnlist?.map(
        ({
          title,
          iconStyle,
          buttonType,
          attriType,
          withIcon,
          showCountSection,
          count,
          handleClick,
          isDisabled=false
        }) => {
          return (
            <Box key={buttonType}>
              <Button
                title={title}
                iconStyle={iconStyle}
                buttonType={buttonType}
                attriType={attriType}
                withIcon={withIcon}
                showCountSection={showCountSection}
                count={count}
                handleClick={handleClick}
                isDisabled={isDisabled}
              />
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default FooterButtonSection;
FooterButtonSection.propTypes = {
  footerStyle:PropTypes.any, 
  btnlist:PropTypes.any
}